import axios from 'axios';

const getBrandeddata = async (url: string) => {
  const data = await axios.get(url);
  return data;
};
const data = {getBrandeddata};
export default data;
